<template>
    <section>
        <b-modal v-model="open" :title="$t('message.increase_transmitter_limit')" ref="modal" id="upgrade">
            <p v-html="$t('message.increase_transmitter_limit_explanation')"></p>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.close')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    export default {
        name: 'Upgrade',
        data () {
            return {
                open: false
            }
        }
    }
</script>

<style scoped>

</style>